import { axiosInstance } from "@/axios/interceptors";
import { z } from "zod";

export type GuestBusinessDetailsPayload = {
	business_name: string;
	address: string;
	address_line_2?: string | null;
	city: string;
	zipcode: string;
	global_state_id: number;
	global_country_id: number;
	business_phone: string;
	business_phone_global_country_id: number;
	ein_number: string | null;
};

export const GuestBusinessDetailsRecordSchema = z.object({
	id: z.number(),
	guest_id: z.number(),
	business_name: z.string(),
	address: z.string(),
	address_line_2: z.string().nullable().optional(),
	city: z.string(),
	zipcode: z.string(),
	global_state_id: z.number(),
	global_country_id: z.number(),
	country: z.object({
		id: z.number(),
		name: z.string(),
		code: z.string(),
	}),
	state: z.object({
		id: z.number(),
		name: z.string(),
		code: z.string(),
	}),

	business_phone: z.string(),
	business_phone_global_country_id: z.number(),
	ein_number: z.string().nullable().optional().default(null),
});

export type GuestBusinessDetailsRecord = z.infer<
	typeof GuestBusinessDetailsRecordSchema
>;

export async function postGuestBusinessDetails(
	locationId: number,
	guestId: number,
	payload: GuestBusinessDetailsPayload,
): Promise<void> {
	await axiosInstance.post(
		`/locations/${locationId}/guests/${guestId}/business_details`,
		payload,
	);
}

export async function putGuestBusinessDetails(
	locationId: number,
	guestId: number,
	businessDetailId: number,
	payload: GuestBusinessDetailsPayload,
): Promise<void> {
	await axiosInstance.put(
		`/locations/${locationId}/guests/${guestId}/business_details/${businessDetailId}`,
		payload,
	);
}
